<template>
  <main class="charts">
    <app-modal></app-modal>

    <div class="static-charts">
      <!--line charts-->

      <app-chart :loading="loading"
                 class="half-width"
                 data-name="access"
                 data-type="line"
                 :data-heading="accessHeading"
                 :data-tooltip="$t('message.statistics.message.tooltipAccesses')"
                 showTotal
                 />

      <app-chart :loading="loading"
                 :totalLabels="['', this.$t('message.statistics.message.newUsers')]"
                 class="half-width"
                 data-name="clients"
                 data-type="line"
                 :data-heading="$t('message.generics.message.users')"
                 :data-tooltip="$t('message.statistics.message.tooltipUsers')"
                 showTotal
                 />

      <app-chart :loading="loading"
                 :totalLabels="[this.$t('message.statistics.message.impressions'),this.$t('message.statistics.message.viewability')]"
                 class="half-width"
                 data-name="impressions"
                 data-type="line"
                 :data-heading="$t('message.statistics.message.impressions')"
                 :data-tooltip="$t('message.statistics.message.tooltipImpressions')"
                 showTotal
                 />

      <app-chart :loading="loading"
                 class="half-width"
                 data-name="weekday"
                 data-type="bar"
                 :data-heading="$t('message.statistics.message.accessesByDay')"
                 :data-tooltip="$t('message.statistics.message.tooltipAccessesByDay')"
                 />

      <app-chart :loading="loading"
                 class="full-width"
                 data-name="accessHour"
                 data-type="line"
                 :data-heading="$t('message.statistics.message.accessesByHour')"
                 :data-tooltip="$t('message.statistics.message.tooltipAccessesByHour')"
                 />

      <statistics-heat-map class="full-width"
                           :loading="loading" />

      <!--doughnut charts-->

      <app-chart :loading="loading"
                 :class="isTopLocalsVisible ? 'half-width' : 'third-width'"
                 data-name="gender"
                 data-type="doughnut"
                 :data-heading="$t('message.statistics.message.gender')"
                 :data-tooltip="$t('message.statistics.message.tooltipGender')"
                 />

      <app-chart :loading="loading"
                 :class="isTopLocalsVisible ? 'half-width' : 'third-width'"
                 data-name="registerType"
                 data-type="doughnut"
                 :data-heading="$t('message.statistics.message.registrationType')"
                 :data-tooltip="$t('message.statistics.message.tooltipRegistrationType')"
                 />

      <app-chart :loading="loading"
                 :class="isTopLocalsVisible ? 'half-width' : 'third-width'"
                 data-name="deviceType"
                 data-type="doughnut"
                 :data-heading="$t('message.statistics.message.devices')"
                 :data-tooltip="$t('message.statistics.message.tooltipDevices')"
                 />

      <app-chart
                 v-if="isTopLocalsVisible"
                 :loading="loading"
                 class="half-width"
                 data-name="topLocals"
                 data-type="doughnut"
                 :data-heading="$t('message.statistics.message.topLocals')"
                 :with-helper-text="isGraphWithHelperText"
                 :helper-text="$t('message.statistics.message.graphHelperText')"
                 />

      <!--cards-->

      <div class="cards">
        <app-statistic-card :loading="loading"
                            data-name="engagement"
                            :data-heading="$t('message.statistics.message.engagement')"
                            data-attachment="%"
                            :data-tooltip="$t('message.statistics.message.tooltipEngagement')" />

        <app-statistic-card :loading="loading"
                            data-name="rejection"
                            :data-heading="$t('message.statistics.message.rejection')"
                            data-attachment="%"
                            :data-tooltip="$t('message.statistics.message.tooltipRejection')" />

        <app-statistic-card :loading="loading"
                            data-name="screenTimeAvg"
                            :data-heading="$t('message.statistics.message.screenTimeAvg')"
                            data-attachment="s"
                            :data-tooltip="$t('message.statistics.message.tooltipScreenTimeAvg')" />

        <app-statistic-card :loading="loading"
                            data-name="ageAverage"
                            :data-heading="$t('message.statistics.message.ageAverage')"
                            :data-attachment="$t('message.statistics.message.years')"
                            :data-tooltip="$t('message.statistics.message.tooltipAgeAverage')" />
      </div>

      <!--bar charts-->

      <app-chart class="half-width"
                 :loading="loading"
                 data-name="age"
                 data-type="bar"
                 :data-heading="$t('message.statistics.message.age')"
                 :data-tooltip="$t('message.statistics.message.tooltipAge')"
                 />

    </div>

    <div v-if="interactionData"
         class="dynamic-charts">
      <template v-for="(chart) in interactionData">

        <app-banner-stats class="half-width"
                          v-if="chart.type === 'BANNER'"
                          :key="chartKey(chart)"
                          :data-stats="chart" />

        <app-poll-stats class="half-width"
                        v-if="chart.type === 'PESQUISA_OBJETIVA'"
                        :key="chartKey(chart)"
                        :data-stats="chart" />

        <app-nps-stats class="half-width"
                       v-if="chart.type === 'PESQUISA_NPS'"
                       :key="chartKey(chart)"
                       :data-stats="chart" />

        <app-open-field-stats class="half-width"
                       v-if="chart.type === 'OPEN_FIELD'"
                       :key="chartKey(chart)"
                       :data-stats="chart" />

        <app-promotion-code-stats class="half-width"
                                  v-if="chart.type === 'CODIGO_PROMOCIONAL'"
                                  :key="chartKey(chart)"
                                  :data-stats="chart" />

      </template>
    </div>

  </main>
</template>

<script>
import StatisticsHeatMap from "@/components/modules/statistics/heat/map/StatisticsHeatMap";

//import _ from 'lodash'
import AppChart from "@components/chart/Chart";
import AppStatisticCard from "@components/StatisticCard";
import AppPollStats from "./components/PollStats";
import AppBannerStats from "./components/BannerStats";
import AppNpsStats from "./components/NpsStats";
import AppOpenFieldStats from "./components/OpenFieldStats";
import AppPromotionCodeStats from "./components/PromotionCodeStats";
import AppModal from "./components/answers-statistics-modal/AnswerStatisticModal";
import EventBus from "@packages/event-bus";
import moment from 'moment';

export default {
  components: {
    AppChart,
    AppStatisticCard,
    AppPollStats,
    AppBannerStats,
    AppNpsStats,
    AppPromotionCodeStats,
    AppModal,
    StatisticsHeatMap,
    AppOpenFieldStats
  },

  data() {
    return {
      dynamicCharts: null,
      loading: false,
      isTopLocalsVisible: true,
      isGraphWithHelperText: true
    };
  },

  computed: {
    locale() {
       return this.$store.state.users.locale
    },

    dataStatistics() {
        return this.$loader.statistics
    },

    filters() {
      return this.$store.state.statistics.filters;
    },

    isEstablishment() {
      return this.$store.state.users.user.tipo === "ESTABELECIMENTO";
    },

    accessHeading() {
      return this.isEstablishment ? this.$t('message.generics.message.accesses') : this.$t('message.generics.message.inserts')
    },

    interactionData() {
      return this.$store.state.statistics.interactionData;
    }
  },

  methods: {
    async loadStatistics() {
      this.loading = true;

      this.checkTopLocalFilter();
      this.checkGraphWithHelperText();

      await this.$loader.statistics.load({
        ...this.filters,
      });

      this.loading = false;
    },

    checkTopLocalFilter(){
        const isAdvertisingArray = Array.isArray(this.filters.advertising)

        if(
            (isAdvertisingArray && this.filters.advertising.length) ||
            (!isAdvertisingArray && this.filters.advertising)
        ){
            this.isTopLocalsVisible = false
            return
        }

        this.isTopLocalsVisible = true
    },

    checkGraphWithHelperText() {
        const endDate = moment(this.$store.state.statistics.filters.date.max, 'YYYY-MM-DD')

        this.isGraphWithHelperText = endDate.isSame(moment(), 'day')
    },

    chartKey(chart) {
      return `${chart.interactionBody.id}-${this.$date.timestamp()}`;
    },
  },

  watch: {
    locale() {
      this.loadStatistics()
    }
  },

  mounted() {
    this.loadStatistics();

    EventBus.$on("STATISTICS_FILTER_RELOAD", this.loadStatistics);
  },

  beforeDestroy() {
    EventBus.$off("STATISTICS_FILTER_RELOAD", this.loadStatistics);
    this.$store.commit("STATISTICS_RESET_FILTERS");
  },
};
</script>

<style lang="scss" scoped>
.charts {
  & > * {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    & > * {
      margin-bottom: 30px;
    }
  }

  .full-width {
    width: calc(100%) !important;
  }

  .static-charts {
    .cards {
      @extend .half-width;

      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      & > * {
        width: calc(50% - 10px);
        height: calc(50% - 10px);

        &:nth-last-child(-n + 3) {
          margin-bottom: 20px;
        }
      }
    }
  }

  .half-width {
    width: calc(50% - 15px) !important;
  }

  .third-width {
    width: calc(33.33% - 22px) !important;
  }
}

@media only screen and (max-width: 1400px) {
  .dynamic-charts > .half-width {
    width: 100% !important;
  }
}
</style>
